import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Company } from "@/types/company"
import { Badge } from "../ui/badge"

interface BulkLicenseDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  companies: Company[]
  isActivating: boolean
}

export function BulkLicenseDialog({
  isOpen,
  onClose,
  onConfirm,
  companies,
  isActivating,
}: BulkLicenseDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {isActivating ? "Lisansları Aktifleştir" : "Lisansları Durdur"}
          </DialogTitle>
          <DialogDescription>
            <p>
              Seçili {companies.length} firmanın lisanslarını{" "}
              {isActivating ? "aktifleştirmek" : "durdurmak"} üzeresiniz.
            </p>
            
            <div className="mt-4 space-y-2">
              <p>Etkilenecek firmalar:</p>
              <div className="max-h-[200px] overflow-y-auto space-y-1">
                {companies.map((company) => (
                  <div key={company._id} className="flex items-center gap-2">
                    <span>{company.name}</span>
                    <Badge
                      variant={company.license.isActive ? "success" : "destructive"}
                      className="ml-2"
                    >
                      {company.license.isActive ? "Aktif" : "Pasif"}
                    </Badge>
                  </div>
                ))}
              </div>
            </div>

            {isActivating ? (
              <div className="mt-4">
                <p>Bu işlem:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Seçili firmaların tüm hizmetlere erişimini açar</li>
                  <li>Yöneticilerin panele girişini aktifleştirir</li>
                  <li>Müzik sistemlerinin çalışmasını sağlar</li>
                </ul>
              </div>
            ) : (
              <div className="mt-4">
                <p>Bu işlem:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Seçili firmaların tüm hizmetlere erişimini durdurur</li>
                  <li>Yöneticilerin panele girişini engeller</li>
                  <li>Müzik sistemlerinin çalışmasını durdurur</li>
                </ul>
                <p className="mt-4 text-destructive">
                  Bu işlem geri alınabilir ancak firmalar hizmetleri kullanamayacağı için dikkatli olun!
                </p>
              </div>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            İptal
          </Button>
          <Button
            variant={isActivating ? "default" : "destructive"}
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            {isActivating ? "Aktifleştir" : "Durdur"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
